import { writeStorageItem } from "../../Api/Utils/apiUtils"
import { POPUP_ACTIVE, POPUP_DEACTIVE, POPUP_NAME } from "../Const/const"

export const popupActive = () => (dispatch) => {
    writeStorageItem(POPUP_NAME, 'false')
    dispatch({
        type: POPUP_ACTIVE
    })
}
export const popupDeActive = () => (dispatch) => {
    writeStorageItem(POPUP_NAME, 'true')
    dispatch({
        type: POPUP_DEACTIVE
    })
}